import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * ProtectedRoutes component for React Router v6
 * Wraps routes that require authentication
 */
export default function ProtectedRoutes({ children }) {
  const { user, isAuthenticated } = useSelector((state) => state.login);
  const location = useLocation();

  // Check if user is authenticated
  const authenticated = isAuthenticated || !!user;

  if (!authenticated) {
    // Redirect to login page with return location
    return (
      <Navigate
        to="/"
        state={{ referrer: location.pathname }}
        replace
      />
    );
  }

  return children;
}
